import axios from "axios";

const exportCustomizeReportingSummary = async (params = {}) => {
  try {
    const response = await axios.post(
      "/distributor/system-admin/summary/v1/data-summary/customize-reporting-summary-export",
      params,
      { responseType: "blob" }
    );
    return response; // Return full response, not just response.data
  } catch (error) {
    console.error("Failed to fetch customize reporting summary:", error);
    throw error.response?.data || error;
  }
};

export default exportCustomizeReportingSummary;
